import { FC } from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { useExpoints } from 'screens/Clients/hooks/useExpoints';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: ' flex-end',
    position: 'fixed',
    bottom: '40px',
    right: '-30px',
    transform: 'rotate(-90deg)',
    zIndex: 1300,
    [theme.breakpoints.down('sm')]: {
      bottom: '50vh',
      right: '-56px',
    },
  },
  feedbackBtn: {
    'padding': theme.spacing(0, 2),
    'color': theme.palette.white.main,
    'backgroundColor': theme.palette.primary.dark,
    'borderRadius': theme.spacing(1, 1, 0, 0),
    'textTransform': 'uppercase',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const FeedbackExpoints: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { callFeedbackSurvey } = useExpoints();

  return (
    <div className={classes.root}>
      <Button
        className={classes.feedbackBtn}
        onClick={() => {
          callFeedbackSurvey();
        }}
      >
        {t('feedback.title')}
      </Button>
    </div>
  );
};

export default FeedbackExpoints;
